<main class="-mt-24 pb-8">
  <div class="max-w-9xl mx-auto px-4 sm:px-6 lg:max-w-9xl lg:px-8">

    <!-- Main 3 column grid -->
    <div class="grid">
      <!-- Left column -->
      <div class="grid grid-cols-1 gap-4 lg:col-span-2">
        <!-- Welcome panel -->
        <section>
          <div class="rounded-lg bg-white overflow-hidden shadow">
            <div class="min-h-fit sm:items-center sm:justify-between">
              <div class="h-full p-6 w-full bg-white">
                <div class="text-center">
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg> -->
                  <img _ngcontent-teg-c247="" alt="" class="mx-auto h-12 w-12 text-gray-400" src="../../../../../../../../assets/wall-clock.png">
                  <h3 class="mt-2 text-xl font-medium font-bold text-gray-900">We're sorry your program is not under
                    coverage at this moment </h3>
                  <p *ngIf="isAnyFutureCoverage==true  && nextCoverageStartDate != '' && nextCoverageStartDate != null" class="mt-1 text-sm text-gray-500">Your next coverage begins at:
                  </p>
                  <div *ngIf="isAnyFutureCoverage==true && nextCoverageStartDate != '' && nextCoverageStartDate != null" class="mt-6">
                    <button type="button"
                      class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                      <!-- Heroicon name: solid/plus -->
                      <!--<svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                        fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                          d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                          clip-rule="evenodd" />
                      </svg>-->
                      {{nextCoverageStartDate}} at {{ this.nextCoverageStartTime | date : 'shortTime' }}
                    </button>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>
